import { useNavigate } from "react-router-dom";
import "./Premium.css"

const Premium = ({ data }) => {
    const premiumModel = data.filter((item) => {
        return item.premium;
      });


    const navigate = useNavigate();

    const makeWish = async (id, title) => {
      try {
        await navigator.clipboard.writeText(
          `Olá gostaria de comprar as modificações do ${title} ${id}`
        );
        console.log("Content copied to clipboard");
        alert(
          "Foi copiado o nome e o código do template, entre em contato em nossas redes sociais e cole o texto copiado"
        );
        navigate("/redes");
      } catch (err) {
        console.error("Failed to copy: ", err);
      }
    };

  return (
    <div className="premium_container">
        <div className="premium_title_container">
            <h2>Modelos Prêmios</h2>
            <span>Modelos selecionados com uma qualidade superior aos padrôes</span>
        </div>
        <div className="all_content">
          {premiumModel &&
            premiumModel.map((item) => (
            <div key={item.id} className="item_container">
              <img src={item.img} alt={item.title}/>
              <p className="title_post">{item.title}</p>
              {item.premium && <span className="span_premium">Prêmio</span>}
              {!item.premium && <span className="span_main">Padrão</span>}
              <div className="buttons_container">
                    <button
                      className="btn_chat"
                      onClick={() => makeWish(item.id, item.title)}
                    >
                      Fazer Pedido
                    </button>
                    <button
                      className="btn_chat"
                      onClick={() => window.open(item.link)}
                    >
                      Ver ao vivo
                    </button>
                  </div>
              </div>
            ))}
          <div className="item_container background_gradient_main" onClick={() => navigate("/")}>
            <span>+</span>
            <p>Ver Todos +</p>
          </div>
        </div>
    </div>
  )
}

export default Premium